/**
 * Valaciclovir drug configuration
 * Indication-agnostic product facts
 */

import type { Drug } from "../types";

export const valaciclovirDrug: Drug = {
  id: "valaciclovir",
  name: "Valaciclovir",
  drugClass: "antiviral (nucleoside analogue prodrug)",
  defaultFoodTiming: "Swallow whole with water",
  formulations: [
    {
      id: "valaciclovir-500-tab",
      type: "tablet_ir",
      strength: 500,
      strengthUnit: "mg",
      dmdCode: "ADD_DM+D_VMP_CODE",
      canCrush: false,
      crushNote: "Swallow whole with water",
      storageNote: "Store below 30°C",
      prescribedItemId: "e2417fac-6d4c-4763-be70-3b811678fd3d",
    },
  ],
};
